module.exports = __webpack_public_path__ + "static/media/profile.bb0ba173.jpg";